<template>
  <div id="Cluster5">
    <PowerSupply @allValues = checkPowerSupply :values="(openFile) ? clusterFive.powerSupply : null" :clear='clear' :title='$t("message.multifunction")'/>
    <Output24 @allValues = checkOutput24 :values="(openFile) ? clusterFive.output24 : null" :clear='clear' :title='$t("message.output24")' :prefix='prefix'/>
    <Output48 @allValues = checkOutput48one :values="(openFile) ? clusterFive.output48one : null" :clear='clear' :title='$t("message.output48") + " 1"'/>
    <Output48 @allValues = checkOutput48two :values="(openFile) ? clusterFive.output48two : null" :clear='clear' :title='$t("message.output48") + " 2"'/>
    <Output48 @allValues = checkOutput48three :values="(openFile) ? clusterFive.output48three : null" :clear='clear' :title='$t("message.output48") + " 3"'/>
    <CallStation @allValues = checkCallStation :values="(openFile) ? clusterFive.callStation : null" :cluster='clusterFive' :clear='clear' :title='$t("message.callStation")'/>
    <NoiseSensor @allValues = checkNoiseSensor :values="(openFile) ? clusterFive.noiseSensor : null" :cluster='clusterFive' :clear='clear' :title='$t("message.noiseSensor")'/>
    <InterfaceControl @allValues = checkinterfaceControl :values="(openFile) ? clusterFive.interfaceControl : null" :cluster='clusterFive' :clear='clear' :title='$t("message.interfaceControl")'/>
    <InterfaceAudio @allValues = checkinterfaceAudio :values="(openFile) ? clusterFive.interfaceAudio : null" :cluster='clusterFive' :clear='clear' :title='$t("message.interfaceAudio")'/>
    <PanelControl @allValues = checkPanelControl :values="(openFile) ? clusterFive.panelControl : null" :cluster='clusterFive' :clear='clear' :title='$t("message.panelControl")'/>

    <div id="btnAkum">
      <button class="btn btn-info" @click="showDialogAkumulatory = true" style="font-size: 12px; line-height: 0px; margin-right: 12px;padding: 5px;background: #666;border: none;">
        <img src="../../assets/icon_battery_white.png" style="width: 25px;margin-right: 10px;">{{$t('message.changeBattery')}}</button>
      <button  v-if="outputs.akumulator_user[prefix] && outputs.akumulators[prefix]" class="btn" @click="clearBattery(prefix)" style="font-size: 12px; line-height: 0px; margin-right: 12px; background:none">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16" style="color:red">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
        </svg>
      </button>

      <div v-if="outputs.akumulator_user[prefix] && outputs.akumulators[prefix]">
        {{outputs.akumulators[prefix].label}}
      </div>

      <button @click="changeActiveBattery()" style="border: medium;  background: none;  color: rgb(0, 163, 227);  font-style: italic;  text-decoration: underline;  cursor: pointer;">
        {{(activeBattery) ? $t('message.wycena_bez_akumulatora') : $t('message.wycena_z_akumulatorem')}}</button>
        <!-- {{(activeBattery) ? $t('message.changeBattery') 'Pomiń wycene akumulatora' : 'Wyceń z akumulatorem'}}</button> -->

    </div>

    <MozliweAkumulatory
      :showDialog="showDialogAkumulatory"
      :moreBatteries="outputs.mozliwe_akumulatory[prefix]"
      :clusterIndex='prefix'
      @clickedClose="closedDialog"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'
import { materials } from '../../mixins/materials'
import { calculation } from '../../mixins/calculation'

import PowerSupply from '../Devices/PowerSupply'
import Output24 from '../Devices/Output24'
import Output48 from '../Devices/Output48'
import CallStation from '../Devices/CallStation'
import NoiseSensor from '../Devices/NoiseSensor'
import InterfaceControl from '../Devices/InterfaceControl'
import InterfaceAudio from '../Devices/InterfaceAudio'
import PanelControl from '../Devices/PanelControl'

import MozliweAkumulatory from '../Dialogs/MozliweAkumulatory'

export default {
  name: 'Cluster5',
  props: ['clear', 'prefix'],
  mixins: [app, materials, calculation],
  components: {PowerSupply, Output24, Output48, CallStation, NoiseSensor, InterfaceControl, InterfaceAudio, PanelControl, MozliweAkumulatory},
  computed: {
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['clusters']),
    ...mapGetters('app', ['openFile']),
    ...mapGetters('app', ['copyValues']),
    ...mapGetters('app', ['clusterOne']),
    ...mapGetters('app', ['clusterTwo']),
    ...mapGetters('app', ['clusterThree']),
    ...mapGetters('app', ['clusterFour']),
    ...mapGetters('app', ['clusterFive']),
    ...mapGetters('app', ['clusterSix']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaBosch']),
    ...mapGetters('products', ['ListaPulsar']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaMaterialy']),
    currentCluster () {
      if (this.sufix) {
        return this.$store.getters[`app/cluster${this.suffix}`]
      }
      return 0
    }
  },
  data () {
    return {
      page: 'cluster5',
      showDialogAkumulatory: false,
      activeBattery: true,
      cluster5: {
        powerSupply: {'selected': 'PRA-MPS3', ethernet: 0, sfp: 0},
        output24: {'selected': '-', ethernet: 0, maxCurrent: 0, countU: 0},
        output48one: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
        output48two: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
        output48three: {'selected': '-', ethernet: 0, loudspeaker: 0, sfp: 0, poe: 0, currentMode: 0, currentAlarm: 0, countU: 0},
        callStation: {csDesktop: 0, csWall: 0, csExt: 0, poePorts: 0, cstEmergency: 0},
        noiseSensor: {poePorts: 0},
        interfaceControl: {poePorts: 0},
        interfaceAudio: {poePorts: 0},
        panelControl: {poePorts: 0}
      }
    }
  },
  watch: {
    clusterFive: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        this.cluster5 = JSON.parse(JSON.stringify(newValue))
      }
    }
  },
  methods: {
    closedDialog (bool) {
      this.pokaz_zestawienie = bool
      this.showDialogAkumulatory = bool
    }
  }
}
</script>

<style scoped>
#nav {
  border-bottom: 1px solid #999
}
#nav button#tab-cluster1, #nav button#tab-cluster2, #nav button#tab-cluster3, #nav button#tab-cluster4, #nav button#tab-cluster5, #nav button#tab-cluster6 {
  background: #fff;
  width: 75px;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #999;
  top: 1px;
  position: relative;
  cursor: pointer;
}
#nav button#tab-cluster1.active, #nav button#tab-cluster2.active, #nav button#tab-cluster3.active, #nav button#tab-cluster4.active, #nav button#tab-cluster5.active, #nav button#tab-cluster6.active {
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  border-right: 1px solid #999;
  border-bottom: 1px solid #fff;
}

select {
  text-align: center;
}
#btnAkum {
  width:100%;
  text-align: left;
  margin-top: 30px;
}
#btnAkum button {
  padding: 10px;
}
.headTd {
  background: #999;
}
#tab {
  font-size: 12px;
}
.desc {
  width:220px
}
.device {
  width:330px;
  float: left;
}
.device-title {
  width:420px
}
.wiersz-pusty {
  height:10px
}
.wariant-label {
  width:74px;
}
.wariant-input {
  width:60px
}
.wariant-rozszerzenia-input {
  width: 60px;
}
.wariant-span {
  font-size: 13px;
  margin: 0px 12px;
}
#tab-main, #tab-other {
  margin-top: 5px;
}
.md-avatar {
  width: 0px;
  min-width: 20px;
  height: 28px;
  border-radius: 0px;
  margin:2px 0px;
}
.tooltipImg  {
  margin-left:50px;
  padding:10px;
  width: 520px;
  height: 400px;
  font-size: 14px;
  background: white !important;
  border: 3px solid #215D8C !important;
}
.tooltipImg img {
  padding: 10px;
  font-size: 14px;
}
.tooltipImg h4 {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.tooltipImg p {
  color: #333;
  font-size: 16px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Clusters/Cluster5.vue